import React from 'react';

// Har ingredient ka apna asli (real-looking) illustration — emoji ki jagah.
// All inline SVGs: no extra image requests, no downloads, the website stays fast.
// Matched by name (even if the name is changed from the admin panel, keywords still identify it).

const S = { width: '100%', height: '100%', display: 'block' };

/* ── Unoxidized (green) tea: bud + do patte ── */
const TeaLeaf = () => (
  <svg viewBox="0 0 64 64" style={S} aria-hidden="true">
    <defs>
      <linearGradient id="ii-tea1" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stopColor="#a8d65a" /><stop offset="1" stopColor="#3d8a2e" /></linearGradient>
      <linearGradient id="ii-tea2" x1="1" y1="0" x2="0" y2="1"><stop offset="0" stopColor="#8fc94a" /><stop offset="1" stopColor="#2f7a2a" /></linearGradient>
      <linearGradient id="ii-tea3" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stopColor="#d3ec8a" /><stop offset="1" stopColor="#66b13c" /></linearGradient>
    </defs>
    <path d="M30 54C12 50 6 32 12 16c16 2 26 16 18 38z" fill="url(#ii-tea1)" />
    <path d="M34 54c18-4 24-22 18-38-16 2-26 16-18 38z" fill="url(#ii-tea2)" />
    <path d="M32 56C22 42 24 22 32 8c8 14 10 34 0 48z" fill="url(#ii-tea3)" />
    <path d="M30 52C24 42 18 30 14 20M34 52c6-10 12-22 16-32M32 54V14" stroke="#2c6a25" strokeOpacity=".55" strokeWidth="1.3" fill="none" strokeLinecap="round" />
  </svg>
);

const seedFill = (id, a, b) => (
  <linearGradient id={id} x1="0" y1="0" x2="1" y2="1"><stop offset="0" stopColor={a} /><stop offset="1" stopColor={b} /></linearGradient>
);

/* ── Fennel seeds (saunf): lambe, dhaari-daar, halke hare ── */
const FENNEL = [[22, 44, -30], [32, 46, 8], [42, 44, 34], [27, 33, -14], [38, 33, 20], [32, 22, 4], [20, 28, -50], [45, 30, 48], [32, 36, 60]];
const Fennel = () => (
  <svg viewBox="0 0 64 64" style={S} aria-hidden="true">
    <defs>{seedFill('ii-fen', '#c4c47a', '#7f8c3f')}</defs>
    {FENNEL.map(([x, y, r], i) => (
      <g key={i} transform={`translate(${x} ${y}) rotate(${r})`}>
        <path d="M0-11C5-7 5 7 0 11C-5 7-5-7 0-11z" fill="url(#ii-fen)" stroke="#6b7733" strokeWidth=".8" />
        <path d="M-1.6-6V6M1.6-6V6" stroke="#f0f0b8" strokeOpacity=".7" strokeWidth=".9" strokeLinecap="round" />
      </g>
    ))}
  </svg>
);

/* ── Carom seeds (ajwain): chhote, bhoore, ek taraf chhoti dandi ── */
const CAROM = [[20, 46, 20], [30, 48, -10], [41, 46, 30], [50, 42, -20], [24, 36, -30], [35, 37, 15], [45, 33, -5], [18, 26, 40], [29, 26, -25], [40, 23, 25], [50, 22, -35], [32, 14, 0]];
const Carom = () => (
  <svg viewBox="0 0 64 64" style={S} aria-hidden="true">
    <defs>{seedFill('ii-car', '#b98d58', '#6f4e2a')}</defs>
    {CAROM.map(([x, y, r], i) => (
      <g key={i} transform={`translate(${x} ${y}) rotate(${r})`}>
        <path d="M0-6C5-5 6 3 0 6C-6 3-5-5 0-6z" fill="url(#ii-car)" stroke="#5a3d20" strokeWidth=".7" />
        <path d="M-1.5-4V4M1.5-4V4" stroke="#e8cfa2" strokeOpacity=".6" strokeWidth=".7" />
        <path d="M0-6v-3" stroke="#6f4e2a" strokeWidth="1.2" strokeLinecap="round" />
      </g>
    ))}
  </svg>
);

/* ── Dried mint (pudina): dandi + kinare-daar patte ── */
const MintLeaf = ({ x, y, r, s = 1, fill }) => (
  <g transform={`translate(${x} ${y}) rotate(${r}) scale(${s})`}>
    <path d="M0 0C-9-6-10-18 0-27C10-18 9-6 0 0z" fill={fill} stroke="#2c6b2a" strokeWidth=".8" />
    <path d="M0-1V-24M0-8L-4-12M0-8L4-12M0-15L-4-19M0-15L4-19" stroke="#dff2b4" strokeOpacity=".8" strokeWidth=".9" fill="none" strokeLinecap="round" />
  </g>
);
const Mint = () => (
  <svg viewBox="0 0 64 64" style={S} aria-hidden="true">
    <path d="M32 60V22" stroke="#4d8a2e" strokeWidth="2.2" strokeLinecap="round" />
    <MintLeaf x={32} y={24} r={0} s={0.85} fill="#7cc24a" />
    <MintLeaf x={32} y={42} r={-58} s={0.95} fill="#5fae3a" />
    <MintLeaf x={32} y={42} r={58} s={0.95} fill="#68b83f" />
    <MintLeaf x={32} y={54} r={-75} s={0.7} fill="#4f9d35" />
    <MintLeaf x={32} y={54} r={75} s={0.7} fill="#58a63a" />
  </svg>
);

/* ── Ceylon cinnamon: lipti hui chhaal ki sticks ── */
const Stick = ({ y, x = 0, w = 46 }) => (
  <g>
    <rect x={10 + x} y={y} width={w} height="10.5" rx="5.2" fill="url(#ii-cin)" />
    <path d={`M${16 + x} ${y + 3}H${w + 4 + x}M${14 + x} ${y + 7}H${w + 6 + x}`} stroke="#e0a56b" strokeOpacity=".7" strokeWidth=".9" strokeLinecap="round" />
    <ellipse cx={10 + x + 4} cy={y + 5.25} rx="3.4" ry="5.2" fill="#b26a35" stroke="#7a4420" strokeWidth=".8" />
    <path d={`M${10 + x + 4} ${y + 5.25}m-1.2 0a1.2 1.2 0 1 1 2.4 0a2.4 2.4 0 1 1-4.8 0`} stroke="#6b3a19" strokeWidth=".8" fill="none" />
  </g>
);
const Cinnamon = () => (
  <svg viewBox="0 0 64 64" style={S} aria-hidden="true">
    <defs>
      <linearGradient id="ii-cin" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stopColor="#d99555" /><stop offset="1" stopColor="#8f4f24" /></linearGradient>
    </defs>
    <g transform="rotate(-28 32 32)">
      <Stick y={14} x={2} w={44} />
      <Stick y={26} x={4} w={46} />
      <Stick y={38} x={0} w={44} />
      <rect x="30" y="10" width="4.6" height="44" rx="2" fill="#d8c08a" stroke="#a88f55" strokeWidth=".6" />
    </g>
  </svg>
);

/* ── Nigella (kalonji): kaale, tikone beej ── */
const NIGELLA = [[20, 46, 15], [30, 50, -20], [41, 48, 40], [50, 42, -10], [23, 36, -35], [34, 39, 10], [45, 34, 30], [17, 26, 20], [28, 27, -15], [39, 24, 35], [49, 22, -25], [32, 14, 5], [22, 17, -40]];
const Nigella = () => (
  <svg viewBox="0 0 64 64" style={S} aria-hidden="true">
    <defs>{seedFill('ii-nig', '#3a3a3a', '#0b0b0b')}</defs>
    {NIGELLA.map(([x, y, r], i) => (
      <g key={i} transform={`translate(${x} ${y}) rotate(${r})`}>
        <path d="M0-6.5L4.4 3.2Q0 6.8-4.4 3.2z" fill="url(#ii-nig)" stroke="#000" strokeWidth=".6" strokeLinejoin="round" />
        <path d="M-1.4-2L-0.6 2" stroke="#9a9a9a" strokeOpacity=".7" strokeWidth=".8" strokeLinecap="round" />
      </g>
    ))}
  </svg>
);

/* ── Cardamom (elaichi): hare, dhaari-daar pods ── */
const Pod = ({ x, y, r, s = 1 }) => (
  <g transform={`translate(${x} ${y}) rotate(${r}) scale(${s})`}>
    <path d="M0-19C10-11 10 11 0 19C-10 11-10-11 0-19z" fill="url(#ii-card)" stroke="#3f7a2c" strokeWidth=".9" />
    <path d="M-4-13C-6-4-6 4-4 13M0-17V17M4-13C6-4 6 4 4 13" stroke="#e4f3b0" strokeOpacity=".65" strokeWidth=".9" fill="none" strokeLinecap="round" />
    <path d="M0-19v-3" stroke="#7a8a3a" strokeWidth="1.6" strokeLinecap="round" />
  </g>
);
const Cardamom = () => (
  <svg viewBox="0 0 64 64" style={S} aria-hidden="true">
    <defs>
      <linearGradient id="ii-card" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stopColor="#b6dc74" /><stop offset="1" stopColor="#4f8f34" /></linearGradient>
    </defs>
    <Pod x={20} y={38} r={-32} s={0.95} />
    <Pod x={44} y={38} r={32} s={0.95} />
    <Pod x={32} y={32} r={0} s={1.05} />
  </svg>
);

/* ── Black pepper (kali mirch): jhurriyon wale gol daane ── */
const Corn = ({ x, y, r = 8 }) => (
  <g>
    <circle cx={x} cy={y} r={r} fill="url(#ii-pep)" stroke="#1a0f0a" strokeWidth=".7" />
    <path d={`M${x - r * 0.6} ${y - r * 0.2}q${r * 0.4}-${r * 0.5} ${r * 0.9}-${r * 0.3}M${x - r * 0.3} ${y + r * 0.45}q${r * 0.5} ${r * 0.2} ${r * 0.9}-${r * 0.2}`} stroke="#6b5646" strokeOpacity=".8" strokeWidth=".9" fill="none" strokeLinecap="round" />
    <ellipse cx={x - r * 0.35} cy={y - r * 0.4} rx={r * 0.22} ry={r * 0.14} fill="#fff" fillOpacity=".45" />
  </g>
);
const Pepper = () => (
  <svg viewBox="0 0 64 64" style={S} aria-hidden="true">
    <defs>
      <radialGradient id="ii-pep" cx=".35" cy=".3" r=".9"><stop offset="0" stopColor="#6a5344" /><stop offset=".55" stopColor="#2f2119" /><stop offset="1" stopColor="#120a07" /></radialGradient>
    </defs>
    <Corn x={22} y={42} r={9} />
    <Corn x={42} y={44} r={9.5} />
    <Corn x={32} y={26} r={9.5} />
    <Corn x={16} y={24} r={6.5} />
    <Corn x={50} y={26} r={6.5} />
  </svg>
);

const MATCHERS = [
  [/tea|chai/i, TeaLeaf],
  [/fennel|saunf|sonf/i, Fennel],
  [/carom|ajwain|ajwayan/i, Carom],
  [/mint|pudina|pudeena/i, Mint],
  [/cinnamon|dalchini|darchini/i, Cinnamon],
  [/nigella|kalonji|black seed/i, Nigella],
  [/cardamom|elaichi|ilaichi/i, Cardamom],
  [/pepper|kali mirch/i, Pepper],
];

export default function IngredientIcon({ name, fallback }) {
  const hit = MATCHERS.find(([re]) => re.test(name || ''));
  if (!hit) return <span aria-hidden="true">{fallback || '🌿'}</span>;
  const Icon = hit[1];
  return <Icon />;
}
